var map = {
	"./chat": "0c77",
	"./chat.ts": "0c77",
	"./navBar": "278e",
	"./navBar.ts": "278e",
	"./sideBar": "2001",
	"./sideBar.ts": "2001"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d30e";
module.exports = webpackAsyncContext;